import { Users, Briefcase } from "lucide-react";
import { Reveal } from "./Reveal";
import { FLEET } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export const Fleet = () => {
  const { t } = useLang();

  return (
    <section
      id="flotta"
      data-testid="fleet-section"
      className="scroll-mt-20 py-24 md:py-32 bg-[#0A0A0C] border-t border-[#C5A059]/15"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="block text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">
            {t.fleet.overline}
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-2xl">
            {t.fleet.title}
          </h2>
          <p className="mt-4 text-zinc-400 font-light max-w-xl">{t.fleet.subtitle}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {FLEET.map((car, i) => (
            <Reveal key={car.name} delay={i * 0.1}>
              <article
                data-testid="fleet-card"
                className="group h-full bg-[#141417] border border-[#C5A059]/20 hover:border-[#C5A059]/50 hover:shadow-[0_0_24px_rgba(197,160,89,0.15)] transition-all duration-500"
              >
                <div className="relative h-60 overflow-hidden">
                  <img
                    src={car.img}
                    alt={`${car.name} ${t.fleet.items[i].variant}`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-2xl text-white">{car.name}</h3>
                  <p className="text-sm text-zinc-400 mt-1">{t.fleet.items[i].variant}</p>
                  <p className="text-sm text-zinc-400 font-light mt-4">{t.fleet.items[i].note}</p>
                  <div className="mt-6 pt-6 border-t border-[#C5A059]/30 flex items-center gap-6 text-sm text-zinc-300">
                    <span className="flex items-center gap-2">
                      <Users className="h-4 w-4 text-[#C5A059]" />
                      {t.fleet.items[i].seats}
                    </span>
                    <span className="flex items-center gap-2">
                      <Briefcase className="h-4 w-4 text-[#C5A059]" />
                      {t.fleet.items[i].luggage}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
